/**
 * EventBus
 *
 * Used as a global event bus pattern.
 */
import mitt from 'mitt'

export enum BusEvent {
  SELECTED_PROFILE_LOCATION_CHANGED = 'selected-profile-location-changed',
}

export default mitt()
